import { FORM_SCHEDULE_STATUS } from '../src/components/stores/constants/constants.stores'

const TABLES_SQLITE_DEFAULT = {
    SQLITE_SEQUENCE: 'sqlite_sequence',
}

export const TABLE_NAME = {
    USER_PROFILE: 'user_profiles',
    VERSIONS: 'versions',
    POSTS: 'posts',
    POSTS_VIEWED: 'viewed_posts',
    LEARNING_CATEGORIES: 'learning_categories',
    LEARNING_COURSES: 'learning_courses',
    LEARNING_CONTENTS: 'learning_contents',
    LEARNING_EVALUATIONS: 'learning_evaluations',
    LEARNING_ANSWERS_EVALUATIONS: 'answers_learning_evaluations',
    LEARNING_SAVE_PROGRESS_TRAINING: 'save_progress_training',
    LEARNING_ANSWER_SURVEY: 'answers_learning_surveys',
    PORTFOLIO_CATEGORIES: 'ecommerce_categories',
    PORTFOLIO_PRODUCTS: 'ecommerce_products',
    PORTFOLIO_BRANDS: 'ecommerce_brands',
    REACTIONS: 'reactions',
    BENEFIT_VOUCHERS: 'benefit_vouchers',
    BENEFIT_REDEEMS: 'benefit_redeems',
    BENEFIT_POINTS_AWARDED: 'benefit_awarded_points',
    FOOTER_APP: 'footer_app',
    TRACKINGS: 'trackings',
    SCHEDULE_STORES: 'stores',
    SCHEDULE_STORES_INDICATORS: 'stores_indicators',
    SCHEDULE_STORE_FORMS: 'stores_forms',
    SCHEDULE_CAMPAINGS: 'campaings',
    SCHEDULES: 'schedules',
    SCHEDULE_FORMS_QUESTION_ANSWERS: 'form_question_answers',
    SCHEDULE_SCHEDULES_POS: 'schedules_pos',
    SCHEDULE_ADVANCES: 'schedules_advances',
    SCHEDULE_CHECKIN: 'transaction_checkins',
    SCHEDULE_CHECKOUT: 'transaction_checkouts',
    SCHEDULE_CHECKIN_STEPS: 'checkin_steps',
    SCHEDULE_ACTIVITIES_ADVANCES: 'schedules_activities_advances',
    SCHEDULE_FORMS_ADDITIONALS: 'forms_additionals',
    SCHEDULE_CREATE_STORES: 'create_stores',
    SCHEDULE_FORMS_PERFECT_STORE: 'forms_perfect_stores',
    SCHEDULE_STORES_PF_RELATION: 'perfect_stores_relation',
    SCHEDULE_ASSETS_PF_LINKS: 'assets_pf_links',
    UPLOAD_IMAGES_PENDING: 'upload_images_pending',
    SCHEDULE_STORES_PENDING_SEND: 'stores_pending_send',
    SCHEDULE_FORMS_PENDING_SYNC: 'forms_pending_sync',
    SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS: 'schedules_activities_advances_pendings',
}

export const TABLES_EXEPTIONS = [
    TABLE_NAME.USER_PROFILE,
    TABLE_NAME.SCHEDULE_CHECKIN,
    TABLE_NAME.SCHEDULE_CHECKOUT,
    TABLE_NAME.FOOTER_APP,
    TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS,
    TABLES_SQLITE_DEFAULT.SQLITE_SEQUENCE,
]

export const TABLES_PENDINGS = [
    { name: TABLE_NAME.SCHEDULE_CHECKOUT, statusField: 'status', status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION },
    { name: TABLE_NAME.SCHEDULE_CHECKIN, statusField: 'status', status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION },
    {
        name: TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS,
        statusField: 'status',
        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
    },
    { name: TABLE_NAME.LEARNING_ANSWERS_EVALUATIONS, statusField: null },
    { name: TABLE_NAME.LEARNING_ANSWER_SURVEY, statusField: null },
    {
        name: TABLE_NAME.SCHEDULE_SCHEDULES_POS,
        statusField: 'campaign_status',
        status_pending: FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
    },
    { name: TABLE_NAME.UPLOAD_IMAGES_PENDING, statusField: null },
]

export const TABLES_LEARNING = [
    TABLE_NAME.LEARNING_CATEGORIES,
    TABLE_NAME.LEARNING_COURSES,
    TABLE_NAME.LEARNING_CONTENTS,
    TABLE_NAME.LEARNING_EVALUATIONS,
]

export const TABLES_SCHEDULE = [
    TABLE_NAME.SCHEDULE_CAMPAINGS,
    TABLE_NAME.SCHEDULES,
    TABLE_NAME.SCHEDULE_SCHEDULES_POS,
    TABLE_NAME.SCHEDULE_ADVANCES,
    TABLE_NAME.SCHEDULE_STORE_FORMS,
    TABLE_NAME.SCHEDULE_STORES,
    TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS,
]

interface TableSchema {
    name: string
    schema: string
}

export const TABLES_SCHEMAS: TableSchema[] = [
    {
        name: TABLE_NAME.VERSIONS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.VERSIONS} (
                serviceName TEXT PRIMARY KEY,
                value INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.POSTS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.POSTS} (
                _id TEXT PRIMARY KEY,
                date_publish_date TEXT,
                date_publish TEXT,
                description_long TEXT,
                description_short TEXT,
                labels TEXT,
                liked BOOLEAN,
                link_share TEXT,
                medias TEXT,
                likes_counter INTEGER,
                publication_date TEXT,
                reaction_counter TEXT,
                reactions TEXT,
                title TEXT,
                go_to TEXT,
                complete BOOLEAN,
                status_favourite INTEGER,
                views INTEGER,
                post_height INTEGER,
                comment_count INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_CATEGORIES,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_CATEGORIES} (
                _id TEXT PRIMARY KEY,
                category_name TEXT,
                description TEXT,
                cover_image TEXT,
                channel_icon TEXT,
                action TEXT,
                blocked_by TEXT,
                repository TEXT,
                category_home BOOLEAN,
                status INTEGER,
                category_index INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_COURSES,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_COURSES} (
                _id TEXT PRIMARY KEY,
                blocked_by TEXT,
                date TEXT,
                title TEXT,
                cover_image TEXT,
                description_short TEXT,
                description_long TEXT,
                share BOOLEAN,
                progressive_mode BOOLEAN,
                likes INTEGER,
                evaluations TEXT,
                type TEXT,
                moduls TEXT,
                status_liked BOOLEAN,
                status INTEGER,
                category_id TEXT,
                assessmentResult TEXT,
                course_index INTEGER,
                certificate TEXT,
                download_zip TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_CONTENTS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_CONTENTS} (
                _id TEXT PRIMARY KEY,
                evaluations TEXT,
                course_name TEXT,
                media TEXT,
                content_type TEXT,
                title TEXT,
                description_short BOOLEAN,
                description_long TEXT,
                media_slides TEXT,
                link_share TEXT,
                status INTEGER,
                assessmentResult TEXT,
                cover_image TEXT,
                certificate TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_EVALUATIONS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_EVALUATIONS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                can_repeat TEXT,
                can_repeat_failure TEXT,
                can_repeat_success TEXT,
                type_assessment TEXT,
                questions TEXT,
                count_questions TEXT,
                questions_random BOOLEAN,
                assessmentResult TEXT,
                survey TEXT,
                approval_rate TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_ANSWERS_EVALUATIONS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_ANSWERS_EVALUATIONS} (
                _id TEXT PRIMARY KEY,
                course_id TEXT,
                content_id TEXT,
                answers TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_SAVE_PROGRESS_TRAINING,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_SAVE_PROGRESS_TRAINING} (
                _id TEXT PRIMARY KEY,
                status INTEGER,
                moduls TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.PORTFOLIO_CATEGORIES,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.PORTFOLIO_CATEGORIES} (
                    _id TEXT PRIMARY KEY,
                    name TEXT,
                    description_short TEXT,
                    description_long TEXT,
                    image TEXT,
                    categories TEXT,
                    products TEXT,
                    father_id TEXT,
                    categoy_index INTEGER,
                    level INTEGER,
                    brands TEXT,
                    index_category INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.PORTFOLIO_PRODUCTS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.PORTFOLIO_PRODUCTS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                description_short TEXT,
                description_long TEXT,
                brand TEXT,
                category_id TEXT,
                medias TEXT,
                ean TEXT,
                sku TEXT,
                download_links TEXT,
                index_product INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.PORTFOLIO_BRANDS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.PORTFOLIO_BRANDS} (
                _id TEXT PRIMARY KEY,
                status INTEGER,
                name TEXT,
                index_brand INTEGER
            );
        `,
    },
    {
        name: TABLE_NAME.USER_PROFILE,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.USER_PROFILE} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                last_name TEXT,
                email TEXT ,
                user_name TEXT,
                role  TEXT ,
                avatar TEXT,
                timeZone TEXT,
                user_segment TEXT,
                name_group TEXT,
                ws_url TEXT,
                delete_active BOOLEAN,
                lat REAL,
                lng REAL,
                last_update_coords TEXT,
                url_uploads TEXT,
                languages TEXT,
                lenguage TEXT,
                phone TEXT,
                email_verified BOOLEAN,
                phone_verified BOOLEAN,
                cognito_id TEXT,
                login BOOLEAN,
                image_splash TEXT,
                area TEXT,
                nickname TEXT,
                dni TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.LEARNING_ANSWER_SURVEY,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.LEARNING_ANSWER_SURVEY} (
                _id TEXT PRIMARY KEY,
                post_id TEXT,
                survey_id TEXT,
                answers TEXT
            );
        `,
    },
    {
        name: TABLE_NAME.REACTIONS,
        schema: `
            CREATE TABLE IF NOT EXISTS ${TABLE_NAME.REACTIONS} (
                _id TEXT PRIMARY KEY,
                reactions_count INTEGER,
                reactions_index INTEGER,
                name TEXT,
                isSelected BOOLEAN
            );
        `,
    },
    {
        name: TABLE_NAME.BENEFIT_VOUCHERS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.BENEFIT_VOUCHERS} (
            _id TEXT PRIMARY KEY,
            cover_image TEXT,
            description_short TEXT,
            description_long TEXT,
            points TEXT,
            title TEXT,
            terms_and_conditions TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.BENEFIT_REDEEMS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.BENEFIT_REDEEMS} (
            _id TEXT PRIMARY KEY,
            name TEXT,
            points TEXT,
            status INTEGER,
            date TEXT,
            image TEXT,
            user_id TEXT,
            user_name TEXT,
            modification_date TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.BENEFIT_POINTS_AWARDED,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.BENEFIT_POINTS_AWARDED} (
            _id TEXT PRIMARY KEY,
            name TEXT,
            points TEXT,
            status INTEGER,
            date TEXT,
            image TEXT,
            user_id TEXT,
            user_name TEXT,
            modification_date TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.FOOTER_APP,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.FOOTER_APP} (
            _id TEXT PRIMARY KEY,
            label TEXT,
            icon TEXT,
            nav BOOLEAN,
            section BOOLEAN,
            name TEXT,
            footer_index INTEGER
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_STORES,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_STORES} (
            _id TEXT PRIMARY KEY,
            name TEXT,
            address TEXT,
            lat REAL,
            lng REAL,
            code TEXT,
            cluster TEXT,
            area TEXT,
            region TEXT,
            format TEXT,
            flag TEXT,
            maximum_distance_for_checkin INTEGER,
            segment TEXT,
            distributor_id TEXT,
            existsInDB BOOLEAN,
            organization_id TEXT,
            status_send INTEGER,
            _id_mongoDB TEXT,
            frequency TEXT,
            topstore TEXT,
            potencial TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_STORES_INDICATORS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_STORES_INDICATORS} (
            store_id TEXT PRIMARY KEY,
            indicators TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.POSTS_VIEWED,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.POSTS_VIEWED} (
            _id TEXT PRIMARY KEY,
            date TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_STORE_FORMS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_STORE_FORMS} (
            _id TEXT PRIMARY KEY,
            index_form INTEGER,
            repeat BOOLEAN,
            can_repeat BOOLEAN,
            icon TEXT,
            check_in BOOLEAN,
            name_form TEXT,
            icon_check TEXT,
            type_form TEXT,
            contents TEXT,
            segments TEXT,
            status INTEGER,
            progress BOOLEAN,
            totalScore INTEGER,
            show_barcode BOOLEAN,
            tags TEXT,
            wise BOOLEAN,
            heladera BOOLEAN,
            create_refrigerator BOOLEAN,
            form_id_father TEXT,
            start_ejecution TEXT,
            end_ejecution TEXT,
            link TEXT,
            objective INTEGER,
            weigh INTEGER,
            scores TEXT,
            weights TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_CAMPAINGS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_CAMPAINGS} (
            _id TEXT PRIMARY KEY,
            name TEXT,
            code TEXT,
            image TEXT,
            date_init TEXT,
            date_finish TEXT,
            steps TEXT,
            total_progres INTEGER,
            schedules TEXT,
            camp_values TEXT,
            schedule_free BOOLEAN,
            date_moderation_init TEXT,
            date_moderation_finish TEXT,
            moderation BOOLEAN
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULES,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULES} (
             _id TEXT PRIMARY KEY,
            date_init TEXT,
            date_finish TEXT,
            form_finish TEXT,
            form_init TEXT,
            stores TEXT,
            campaign_id TEXT,
            progress_diary BOOLEAN,
            additional TEXT,
            activities TEXT,
            others_activities TEXT,
            distributor TEXT,
            vacation BOOLEAN,
            activities_advances TEXT,
            others_activities_advances TEXT,
            forms_additionals TEXT,
            forms_incidence TEXT,
            reports TEXT,
            data_version INTEGER
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_FORMS_QUESTION_ANSWERS} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            repeat BOOLEAN,
            date_init TEXT,
            schedule_id TEXT,
            form_id TEXT,
            status INTEGER,
            store_id TEXT,
            answers TEXT,
            questions TEXT,
            progress BOOLEAN,
            totalScore INTEGER,
            scoreObtained INTEGER,
            cant_questions_yes_na INTEGER,
            progress_questions_yes_na INTEGER,
            scoreTotalQuestionsPonderar INTEGER,
            name_form TEXT, 
            heladera BOOLEAN,
            create_refrigerator BOOLEAN, 
            type_form TEXT,
            form_id_father TEXT,
            status_send INTEGER,
            checkout BOOLEAN,
            day_unique_id TEXT,
            checkin_id TEXT,
            scoreTotalQuestionsPonderarFloat FLOAT,
            scoreObtainedFloat FLOAT,
            scoresByKey TEXT,
            totalByKey TEXT,
            date_finish TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_SCHEDULES_POS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_SCHEDULES_POS} (
            _id TEXT PRIMARY KEY,
            store_id TEXT,
            schedule_id TEXT,
            forms_relevant TEXT,
            forms_featured TEXT,
            forms TEXT,
            campaign_status INTEGER,
            lat REAL,
            lng REAL,
            existsInDB BOOLEAN,
            status_send INTEGER
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_ADVANCES,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_ADVANCES} (
            _id TEXT PRIMARY KEY,
            pos_id TEXT,
            schedule_id TEXT,
            forms TEXT,
            status INTEGER,
            date_init TEXT,
            form_id TEXT,
            progress TEXT,
            checkin_id TEXT,
            date_modified TEXT,
            distributor_id TEXT,
            score TEXT,
            objectives TEXT,
            incidence_answer TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.TRACKINGS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.TRACKINGS} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            content_id TEXT,
            date_interaction_init TEXT,
            type_interaction TEXT,
            name_table TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_CHECKIN,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_CHECKIN} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            date TEXT,
            store_id TEXT,
            lat_checkin TEXT,
            lng_checkin TEXT,
            checkin_id TEXT,
            schedule_id TEXT,
            date_init TEXT,
            dif_utc TEXT,
            status INTEGER,
            activities TEXT,
            others_activities TEXT,
            distributor_id TEXT,
            objectives TEXT,
            steps_distributor TEXT,
            formsIdsFqa TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_CHECKIN_STEPS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_CHECKIN_STEPS} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            date TEXT,
            store_id TEXT,
            schedule_id TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_CHECKOUT,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_CHECKOUT} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            date TEXT,
            store_id TEXT,
            lat_checkout TEXT,
            lng_checkout TEXT,
            checkout_id TEXT,
            checkin_id TEXT,
            schedule_id TEXT,
            date_finish TEXT,
            checkin_id_local TEXT,
            dif_utc TEXT,
            status INTEGER,
            distributor_id TEXT,
            forms_view TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_ACTIVITIES_ADVANCES,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_ACTIVITIES_ADVANCES} (
            _id TEXT PRIMARY KEY,
            date TEXT,
            schedule_id TEXT,
            activities TEXT,
            status INTEGER
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_FORMS_ADDITIONALS} (
            _id TEXT PRIMARY KEY,
            title TEXT,
            date TEXT,
            date_finish TEXT,
            icon TEXT,
            questions TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_CREATE_STORES,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_CREATE_STORES} (
            _id TEXT PRIMARY KEY,
            forms TEXT,
            areas TEXT,
            maximum_distance_for_checkin INTEGER
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_FORMS_PERFECT_STORE} (
            _id TEXT PRIMARY KEY,
            status INTEGER,
            form_index INTEGER,
            title TEXT,
            icon TEXT,
            medias TEXT,
            type TEXT,
            start_ejecution TEXT,
            end_ejecution TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_STORES_PF_RELATION,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_STORES_PF_RELATION} (
            _id TEXT PRIMARY KEY,
            pos_id TEXT,
            forms_id TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.UPLOAD_IMAGES_PENDING,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.UPLOAD_IMAGES_PENDING} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            filename TEXT,
            pickerResult_uri TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_ASSETS_PF_LINKS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_ASSETS_PF_LINKS} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            indexRoute INTEGER,
            status INTEGER,
            rute TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_STORES_PENDING_SEND,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_STORES_PENDING_SEND} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            data_send TEXT,
            data_match TEXT
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_FORMS_PENDING_SYNC,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_FORMS_PENDING_SYNC} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            activity_id TEXT,
            status INTEGER,
            date TEXT,
            count INTEGER DEFAULT 1,
            form_name TEXT,
            status_send INTEGER,
            schedule_id TEXT,
            store_id TEXT,
            checkin_id TEXT,
            can_send BOOLEAN DEFAULT 1
        );
    `,
    },
    {
        name: TABLE_NAME.SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS,
        schema: `
        CREATE TABLE IF NOT EXISTS ${TABLE_NAME.SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS} (
            _id INTEGER PRIMARY KEY AUTOINCREMENT,
            schedule_id TEXT,
            activity_id TEXT,
            status INTEGER,
            date TEXT
        );
    `,
    },
]
